import { Icon } from '@aibees/shared/components';
import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

const rotateAnimation = keyframes`
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

export const LoadingIcon = styled(Icon)`
  animation: ${rotateAnimation} 1s linear infinite;
`;

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: flex-start;
`;
